(function () {
  'use strict';

  function resolveTat(pincode) {
    var pinData = window.EDD_PINCODE_DATA || {};
    var tatConfig = window.EDD_TAT_CONFIG || {};
    var entry = pinData[pincode];

    if (!entry) {
      return { found: false };
    }

    var district = (entry[0] || '').trim();
    var state = (entry[1] || '').trim();
    var districtKey = district.toLowerCase();

    var cityBucket = tatConfig.cities && tatConfig.cities[state];
    if (cityBucket && cityBucket[districtKey]) {
      return { found: true, min: cityBucket[districtKey][0], max: cityBucket[districtKey][1], level: 'city', district: district, state: state };
    }

    var stateBucket = tatConfig.states && tatConfig.states[state];
    if (stateBucket) {
      return { found: true, min: stateBucket[0], max: stateBucket[1], level: 'state', district: district, state: state };
    }

    if (tatConfig.default) {
      return { found: true, min: tatConfig.default[0], max: tatConfig.default[1], level: 'default', district: district, state: state };
    }

    return { found: false };
  }

  function addBusinessDays(startDate, days, skipWeekday) {
    var date = new Date(startDate.getTime());
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== skipWeekday) {
        added++;
      }
    }
    return date;
  }

  function formatDate(date) {
    try {
      return new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: '2-digit', month: 'short' }).format(date);
    } catch (e) {
      return date.toDateString();
    }
  }

  function computeDeliveryWindow(minDays, maxDays, cutoffHour, skipWeekday) {
    var now = new Date();
    var dispatchDate = new Date(now.getTime());
    if (now.getHours() >= cutoffHour) {
      dispatchDate.setDate(dispatchDate.getDate() + 1);
    }
    var fromDate = addBusinessDays(dispatchDate, minDays, skipWeekday);
    var toDate = addBusinessDays(dispatchDate, maxDays, skipWeekday);
    return { from: formatDate(fromDate), to: formatDate(toDate) };
  }

  // Everything is delegated from the document. The product block is re-rendered with
  // innerHTML when a colour swatch is clicked, which throws away any listeners bound
  // directly to the old input/button (and does not re-run this script) - so the checker
  // used to go dead after the first swatch click. Delegation survives any re-render.
  var STORE_KEY = 'edd_last_pincode';

  function readStored() {
    try { return sessionStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; }
  }
  function writeStored(v) {
    try { sessionStorage.setItem(STORE_KEY, v); } catch (e) { /* ignore */ }
  }

  function runCheck(root, silentIfEmpty) {
    var input = root.querySelector('[data-edd-input]');
    var resultEl = root.querySelector('[data-edd-result]');
    if (!input || !resultEl) return;

    var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoffHour)) cutoffHour = 18;
    var skipWeekday = parseInt(root.getAttribute('data-skip-weekday'), 10);
    if (isNaN(skipWeekday)) skipWeekday = 0;

    var successPrefix = root.getAttribute('data-success-prefix') || 'Delivery by';
    var invalidText = root.getAttribute('data-invalid-text') || 'Please enter a valid 6-digit pincode';
    var notFoundText = root.getAttribute('data-not-found-text') || "Sorry, we couldn't find delivery info for this pincode";

    function showResult(text, isError) {
      resultEl.textContent = text;
      resultEl.classList.add('is-visible');
      resultEl.classList.toggle('m-edd-checker__result--error', !!isError);
      resultEl.classList.toggle('m-edd-checker__result--success', !isError);
    }

    var pincode = (input.value || '').trim();
    if (!pincode && silentIfEmpty) return;
    if (!/^[1-9][0-9]{5}$/.test(pincode)) {
      showResult(invalidText, true);
      return;
    }

    var tat = resolveTat(pincode);
    if (!tat.found) {
      showResult(notFoundText, true);
      return;
    }

    var window_ = computeDeliveryWindow(tat.min, tat.max, cutoffHour, skipWeekday);
    var dateRange = window_.from === window_.to ? window_.from : (window_.from + ' - ' + window_.to);
    showResult(successPrefix + ' ' + dateRange, false);
    writeStored(pincode);
  }

  if (!window.__eddDelegatedBound) {
    window.__eddDelegatedBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-edd-button]');
      if (!btn) return;
      var root = btn.closest('[data-edd-checker]');
      if (root) runCheck(root, false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('[data-edd-input]');
      if (!input) return;
      var root = input.closest('[data-edd-checker]');
      if (root) {
        e.preventDefault();
        runCheck(root, false);
      }
    });

    document.addEventListener('input', function (e) {
      var input = e.target.closest && e.target.closest('[data-edd-input]');
      if (input) input.value = input.value.replace(/[^0-9]/g, '').slice(0, 6);
    });

    // After a colour swatch swap the checker is a fresh, empty copy: put the shopper's
    // pincode back and show the delivery date again for the new product.
    function restoreAfterSwap() {
      var stored = readStored();
      if (!stored) return;
      document.querySelectorAll('[data-edd-checker]').forEach(function (root) {
        var input = root.querySelector('[data-edd-input]');
        if (input && !input.value) {
          input.value = stored;
          runCheck(root, true);
        }
      });
    }
    document.addEventListener('ProductVariantDataUpdated', function () {
      setTimeout(restoreAfterSwap, 0);
    });
    document.addEventListener('pack:swapped', function () {
      setTimeout(restoreAfterSwap, 0);
    });
  }
})();